//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Nav from "@/components/Nav.vue";
import {mapGetters,mapActions} from 'vuex'
export default {
  name: "schoolList",
  components: {
    Nav
  },
  data() {
    return {
      list: [{}],
      options: [],
      keyValue: "",
      total: 0,
      params: {
        keyword: "",
        limit: 20,
        page: 1,
        area_id: "",
        grade: "",
        fee: "",
        province_id:"",
        catalog:''
      },
      showDrop: false,
      filterType: 0,
      provinceIndex: 0,
      areaIndex: "",
      area: "所在地区",
      grade: "入读年级",
      fee: "全年总费用",
      catalog: "全部类别",
      gradeIndex: "",
      feeIndex: "",
      allIndex:'',
      showlog: false,
      isLoading:false,//是否正在加载数据
      isFirstLoading:true
    };
  },
  computed:{
    ...mapGetters(['searchParams'])
  },
  watch: {
    params:{
      handler:function(){
        console.log('我触发了',this.params);
        this.setSearchParams(this.params);
      },
      deep:true
    },
    provinceIndex(newValue, oldValue){
        this.params.province_id=this.options.addresses[newValue].id
        this.area = this.options.addresses[newValue].title
        this.list=[]
        this.params.page=1
        this.search();
        console.log(12312312,this.area);
    },
    areaIndex(newValue, oldValue) {
      if (newValue !== "") {
        if(newValue!==0){
          this.area = this.options.addresses[this.provinceIndex].children[
            newValue
          ].title;
        } else{
           this.area = this.options.addresses[this.provinceIndex].title
        }
        this.params.area_id = this.options.addresses[
          this.provinceIndex
        ].children[newValue].id;
        this.total = 0;
        this.list = [];
        this.params.page=1
        this.showDrop = false;
        this.search();
      }
    },
    gradeIndex(newValue, oldValue) {
      if (newValue !== "") {
        this.grade = this.options.grades[newValue].title;
        this.params.grade = this.options.grades[newValue].id;
        this.total = 0;
        this.list = [];
        this.params.page=1
        this.showDrop = false;
        this.search();
      }
    },
    feeIndex(newValue, oldValue) {
      if (newValue !== "") {
        this.fee = this.options.fees[newValue].title;
        this.params.fee = this.options.fees[newValue].id;
        this.total = 0;
        this.list = [];
        this.params.page=1
        this.showDrop = false;
        this.search();
      }
    },
    allIndex(newValue, oldValue) {
      if (newValue !== "") {
        this.catalog = this.options.catalogs[newValue].title;
        this.params.catalog = this.options.catalogs[newValue].id;
        this.total = 0;
        this.list = [];
        this.params.page=1
        this.showDrop = false;
        this.search();
      }
    }
  },
  methods: {
    ...mapActions(['setSearchParams']),
    changeProvince(index){
      if(this.provinceIndex==index){
          this.params.province_id=this.options.addresses[index].id
          this.area = this.options.addresses[index].title
          this.list=[]
          this.params.page=1
          this.search();
      }else{
        this.provinceIndex=index
      }
    },
    toDetail(id) {
      this.$router.push({
        name: "schoolDetail",
        query: {
          id: id
        }
      });
    },
    searchKey() {
      this.total = 0;
      this.list = [];
      this.showDrop = false;
      this.search();
    },
    select(index) {
      if (this.showDrop) {
        if (this.filterType == index) {
          this.showDrop = !this.showDrop;
        } else {
          this.filterType = index;
        }
      } else {
        this.filterType = index;
        this.showDrop = !this.showDrop;
      }
    },
    search() {
      this.$api
        .getSchoolList({
          params: this.params
        })
        .then(res => {
          if (res.data.success && res.data.code == 0) {
            let data = res.data.data;
            this.list = this.list.concat(data.items);
            this.total = data.total;
            this.showlog = false;
            this.isLoading = false
            this.isFirstLoading =false
          } else {
            this.$vux.toast.text(res.data.message, "middle");
          }
        });
    },
    getSearchOptions() {
      this.$api.getSearchOptions().then(res => {
        if (res.data.success && res.data.code == 0) {
          let data = res.data.data;
          data.addresses.unshift({
              id:'',
              title:'全部',
              children:[]
          })
          data.addresses=data.addresses.map(val=>{
            val.children.map(child=>{
              data.addresses[0].children.push({
                id:child.id,
                title:child.title
              })
              return child;
            })
            
            return val;
          });
          data.addresses=data.addresses.map(val=>{
            val.children.unshift({
              id:'',
              title:'全部'
            })
            return val;
          });
          data.fees.unshift({
              id:'',
              title:'全部'
          })
          data.grades.unshift({
              id:'',
              title:'全部'
          })
          data.catalogs.unshift({
              id:'',
              title:'全部'
          })
          this.options = data
          // console.log(this.$route.query.id)
          if(this.$route.query.id){
            this.options.addresses.map((val,index)=>{
              if(val.id==this.$route.query.id){
                this.provinceIndex=index
                this.area = this.options.addresses[index].title
                if(this.provinceIndex==0){
                  this.list=[]
                   this.params.page=1;
                  this.search()
                }
                console.log(this.$route.query.id,index)
              }
            })
          }else{
              // this.provinceIndex=0
              // this.area = "所在地区";
              this.list=[];
               this.params.page=1;
              this.search();
          }
          
        } else {
          this.$vux.toast.text(res.data.message, "middle");
        }
      });
    },
    reset() {
      this.total = 0;
      this.list = [];
      this.provinceIndex = 0;
      this.area = "所在地区";
      this.grade = "入读年级";
      this.fee = "全年总费用";
      this.areaIndex = "";
      this.gradeIndex = "";
      this.feeIndex = "";
      this.allIndex = "";
      this.params = {
        keyword: "",
        limit: 20,
        page: 1,
        area_id: "",
        grade: "",
        fee: "",
        province_id:'',
        catalog:''
      };
      this.isFirstLoading=true
    },
    //监听滚动条下拉
    scrool() {
      let that = this;
      var scrollTop = this.$refs.scrollWrapper.scrollTop;
      var clientHeight = this.$refs.scrollWrapper.clientHeight;
      var scrollHeight = this.$refs.scrollWrapper.scrollHeight;
      //HUAWEI个别手机的浏览器页面底部距离有几像素的问题，页面总高度减少一点就好
      if (scrollTop + clientHeight + 100  >= scrollHeight - 5) {
        if (that.params.limit * that.params.page < that.total && !that.isLoading) { 
          that.params.page++;
          that.showlog = true;
          that.isLoading = true
          setTimeout(function() {
            that.search();
          }, 1500);
        }
      }
    }
  },
  created() {

  },
  mounted() {
    this.$refs.scrollWrapper.addEventListener("scroll", this.scrool);
  },
  activated() {
   console.log('aaa')
    if(this.$route.query.id){
      this.params.province_id=this.$route.query.id
    }else{
      this.params.province_id=''
    }
    this.getSearchOptions();
    console.log('this.params==>',this.params);
    // this.search();
  },
  // deactivated(){
  //   this.reset()
  // },
  //组件前置守卫
  // beforeRouteEnter:(to,from,next)=>{
  //   console.log('to==>',to);
  //   console.log('from==>',from);

    
  //   if(from.name === 'schoolDetail'){
  //      next(vm =>{
  //         // console.log('vm==>',vm);
  //         // // vm.isNew = false;
  //         // var keyword = vm.readyKeyword;
  //         // vm.navSearch(keyword);
  //         var searchParams = vm.searchParams;
  //         console.log('searchParams==>',searchParams);
  //         vm.list = [];
  //         //进行搜索
  //         vm.search();



  //     });
  //   }else{
  //     next(vm =>{
  //       //  console.log('this.searchParams==>',vm.searchParams);
  //         vm.reset();
  //     });
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/pages/school/schoolList.vue